/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![XSmallIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA7ElEQVR4nO2TTQ6CMBCFjZ5B0BsZkmmni2Ymkbuw9RR6Dk1YuHZhAv7dRlOxSTFQG2GlvCWZvm9m3jAaDfpPCeQNIO+VSqNPtQutp0JSDsjrcICkXCDfBdLJBzHmgFSYWtNQMMB9KCRdlVrOv6kJhgDyzTXobO6DKJVGvZhbKZVGQnL5gpxNLjYfAI47mbuTWEhvnbdNIRoy6SQAjmtrea7JTMFlyH8S3rms1vL+LdF61ot54hh1htQuR/KlycA917aaRmVZNgakYxUmFeaCvI3YfCRvgwBa64m5EkA6+MxrEEk7gbwKAgz6PT0AO5i3ce94Md4AAAAASUVORK5CYII=)
 */
export const XSmallIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M17.3 18.7a1 1 0 0 0 1.4-1.4L13.42 12l5.3-5.3a1 1 0 0 0-1.42-1.4L12 10.58l-5.3-5.3a1 1 0 0 0-1.4 1.42L10.58 12l-5.3 5.3a1 1 0 1 0 1.42 1.4L12 13.42l5.3 5.3Z"
        className={colorClass}
      />
    </svg>
  );
};
